import { insertSuggestNodeCommand } from "../../core/suggest/suggest";
import { SlashCommandGroup } from "../../core/types";
export const checklistCommandSpec = {
    label: `Insert Checklist`,
    description: `Manage a list of things that need to get done`,
    group: SlashCommandGroup.Advanced,
    icon: "is-checkbox",
    shortcut: "L",
    command: insertSuggestNodeCommand({
        type: "check_list",
        content: [
            {
                type: "check_list_item",
                content: [
                    {
                        type: "paragraph",
                    },
                ],
            },
        ],
    }, 2),
};
